export const API_BASE_URL = "https://bamrec-walkathon.herokuapp.com/api";
export const IMAGE_BASE_URL = "https://bamrec-walkathon.herokuapp.com/uploads/organization_pics/";
export const BASE_URL = "https://bamrec-walkathon.herokuapp.com";
// export const BASE_URL = "https://dev.walkathon.bamrec.com";

// export const API_BASE_URL = 'http://localhost:8080/api'
// export const IMAGE_BASE_URL = 'http://192.168.0.108:3000/uploads/organization_pics/'
// export const BASE_URL = "http://localhost:8080/";
